<template>
    <div class="tooltip-box">
        <div class="van-ellipsis" v-tooltip="{
            content,
            disabled: showTooltip,
            triggers: ['hover', 'focus', 'touch'],
            popperClass: 'text-over-tooltip-class',
        }" @mouseover="onMouseOver()">
            <span :ref="refName">{{ content }}</span>
        </div>
    </div>
</template>

<script>
/**
 * 文字超出一行显示省略号 气泡弹出框
 */
export default {
    name: "overTooltip",
    props: {
        // 显示的文字内容
        content: String,
    },
    data() {
        return {
            showTooltip: true, // 是否需要禁止提示
            refName: Math.random(),
        };
    },
    methods: {
        onMouseOver() {
            let parentWidth = this.$refs[this.refName].parentNode.offsetWidth;
            let contentWidth = this.$refs[this.refName].offsetWidth;
            // 判断是否禁用tooltip功能
            this.showTooltip = contentWidth <= parentWidth;
        },
    },
};
</script>

<style lang="scss" scoped>
.tooltip-box {
    font-size: 14px;
}
</style>
<style lang="scss">
.text-over-tooltip-class {
    font-size: 14px;
    max-width: 80vw;

    .v-popper__arrow-outer {
        border-color: rgba(0, 0, 0, 0.9) !important;
    }

    .v-popper__inner {
        margin: 0 5px;
        background: rgba(0, 0, 0, 0.9) !important;
    }

    * {
        font-size: 14px;
    }
}
</style>
